import * as React from "react";
import * as R from "ramda";
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {Glyphicon} from "react-bootstrap";
import Divider from 'material-ui/Divider';
import icoBuilding from "../../../../../assets/img/ico-building.png";
import icoSura from "../../../../../assets/img/ico-sura-modal.png";
import {Col, Row} from "react-bootstrap";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { DotLoader } from "react-spinners";
import { Mensaje } from "../../general/componentes/Mensaje";
import { Trabajador } from "../modelo/Trabajador";
import { consultarDatosTrabajador } from "../modulos/trabajadores/trabajadoresActions";
import { EstadoDocumento } from "../../documentos/modelo/EstadosDocumento";

class ModalDatosIndependiente extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleShow() {
        const {dniEmpleador, dniIndependiente, id} = this.props;
        this.setState({show: true});
        this.props.dispatch(consultarDatosTrabajador(dniEmpleador, dniIndependiente, id));
    }
    
    handleClose() {
        this.setState({show: false});
    }
    
    render() {
        return(
            <div>
                <a className={"btns btns-primary"} onClick={() => this.handleShow()}>
                    <Glyphicon glyph={"file"}/>
                </a>
                {this.renderModalTrabajador()}
            </div>
        );
    }

    renderModalTrabajador() {
        const btnAcciones = [(
            <FlatButton key={0}
                        label="Cerrar"
                        onClick={() => this.handleClose()}/>
        )];
        return(
            <div>
                <Dialog title={this.rendeEncabezadoModal()}
                        actions={btnAcciones}
                        contentStyle={{width: '82%', maxWidth: 'none'}}
                        open={this.state.show}
                        onRequestClose={() => this.handleClose()}
                        modal={false}>
                    {this.renderContenido()}
                </Dialog>
            </div>
        );
    }

    rendeEncabezadoModal() {
        return (
            <div>
                <Row>
                    <Col sm={8}>
                        {this.props.nombreTrabajador}
                    </Col>
                    <Col smOffset={2} sm={2}>
                        <img src={icoSura}/>
                    </Col>
                </Row>
            </div>
        );
    }

    renderContenido() {
        switch(this.props.estado) {
            case REQUEST.PENDING:
                return (
                    <label>Estamos generando la información por favor espere...<DotLoader size={25}/></label>
                );
            case REQUEST.ERROR:
                return (
                    <Mensaje type={"danger"}
                             mensaje={"Se ha presentado un error generando los datos del trabajador"}/>
                );
            case REQUEST.FORBIDDEN:
                return (
                    <Mensaje type={"danger"}
                                mensaje={"No estas autorizado para consultar esta información"}/>
                );
            case REQUEST.SUCCESS:
                return (
                    <div>
                       {this.renderDatosTrabajador()}
                    </div>
                );
            default:
                return (
                    <label>Cargando...<DotLoader size={25}/></label>
                );
        }
    }

    renderDatosTrabajador() {
        const trabajador: Trabajador = this.props.trabajador;
        return(
            <div>
                <div className="modal-form-text">
                    <label><b>Información del trabajador independiente</b></label>
                    {
                        trabajador.datosAfiliacion.dniGestion && trabajador.datosAfiliacion.fechaGestion && 
                        <div className="subtitle-modal">Gestionado por {trabajador.datosAfiliacion.dniGestion} el {trabajador.datosAfiliacion.fechaGestion}</div>
                    }
                    <Divider/>
                    <br/>
                </div>
                <div>
                    <Row className="form-group modal-form-text">
                        <Col sm={4}>
                            <Row>
                                <Col sm={2}>
                                    <img src={icoBuilding} style={{position: 'absolute', top: 10, left: 15, height: 65, width: 65}}/>
                                </Col>
                                <Col sm={10}>
                                    <p>
                                        <b className="title-col">
                                            <span>{trabajador.datosAfiliacion.nombreEmpleador}</span><br/>
                                            {trabajador.datosAfiliacion.dniEmpleador}
                                        </b>
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col smOffset={2} sm={10}>
                                    <div className="info-col">
                                        <span><b>Centro de Trabajo: </b>{trabajador.datosCentroTrabajo.nombreCentroTrabajo}</span><br/>
                                        <span><b>Código: </b>{trabajador.datosCentroTrabajo.codigoCentroTrabajo}</span><br/>
                                        <span><b>Dirección: </b>{trabajador.datosCentroTrabajo.direccion}</span><br/>
                                        <span><b>Ubicación: </b>{trabajador.datosCentroTrabajo.ciudad} - {trabajador.datosCentroTrabajo.provincia}</span><br/>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={4}>
                            <div className="info-col">
                                <span><b>Documento: </b>{trabajador.documento}</span><br/>
                                <span><b>Teléfono: </b>{trabajador.telefono}</span><br/>
                                <span><b>Correo: </b>{trabajador.correo}</span><br/>
                                <span><b>Género: </b>{trabajador.genero}</span><br/>
                                <span><b>Fecha Nacimiento: </b>{trabajador.fechaNacimiento}</span><br/>
                                <span><b>Domicilio: </b>{trabajador.ciudadDomicilio} - {trabajador.provinciaDomicilio}</span><br/>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className="info-col">
                                <span><b>Tipo Afiliado: </b>{trabajador.datosAfiliacion.tipoAfiliado}</span><br/>
                                <span><b>Pre Registro: </b>{trabajador.datosAfiliacion.preafiliacion}</span><br/>
                                <span><b>Póliza: </b>{trabajador.datosAfiliacion.poliza}</span><br/>
                                <span><b>Inicio Cobertura: </b>{trabajador.datosAfiliacion.inicioCobertura}</span><br/>
                                <span><b>Fin Cobertura: </b>{trabajador.datosAfiliacion.finCobertura}</span><br/>
                                <span><b style={this.estiloEstado(trabajador.datosAfiliacion.estado)}>{trabajador.datosAfiliacion.estado}</b></span>
                                <br/>
                            </div>
                        </Col>
                    </Row>
                    <Row className="form-group modal-form-text">
                        <Col sm={4}>
                            <div className="info-col">
                                <span><b>Ingreso Mensual: </b>${trabajador.ingresoMensual}</span><br/>
                                <span><b>Total Ingresos: </b>${trabajador.totalIngresos}</span><br/>
                                <span><b>Inicio Contrato: </b>{trabajador.inicioContrato}</span><br/>
                                <span><b>Fin Contrato: </b>{trabajador.finalContrato}</span><br/>
                                <span><b>EPS: </b>{trabajador.eps}</span><br/>
                                <span><b>AFP: </b>{trabajador.afp}</span><br/>
                            </div>
                        </Col>
                        <Col sm={8}>
                            <div className="info-col">
                                <span><b>Actividad Económica: </b>{trabajador.datosAfiliacion.actividadEconomica}</span><br/>
                                <span><b>Código: </b>{trabajador.datosAfiliacion.cdActividadEconomica}</span><br/>
                                <span><b>Tasa Cotización: </b>{trabajador.datosAfiliacion.tasaCotizacion}%</span><br/>
                                <span><b>Clase Riesgo: </b>{trabajador.datosAfiliacion.claseRiesgo}</span><br/>
                                <span><b>Tipo Cotizante: </b>{trabajador.datosAfiliacion.tipoCotizante}</span><br/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    estiloEstado = (estado: string) => {
        switch(estado) {
            case EstadoDocumento.aprobado:
                return {color: '#29be20'};
            case EstadoDocumento.rechazado:
                return {color: '#AE0000'};
            case EstadoDocumento.invalido:
                return {color: '#B29D17'};
            case EstadoDocumento.pendiente:
                return {color: '#00328f'};
            default:
                return {color: '#717781'};
        }
    };
}

interface ModalDatosIndependienteProps {
    nombreTrabajador?: string,
    dniEmpleador: string,
    dniIndependiente: string,
    id: string
}

export default connect((store: any, props: ModalDatosIndependienteProps) => {
    return {
        ...props,
        estado: R.pathOr([], ["trabajadores", "estado"])(store),
        trabajador: R.pathOr(undefined, ["trabajadores", "trabajador"])(store)
    };
})(ModalDatosIndependiente);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/ModalDatosIndependiente.tsx